<template>
  <div class="findPassword" >
    <v-topBar :yellowPageColumn='yellowPageColumn' :productAndSolutionColumn='productAndSolutionColumn' :hitSearchUrl='hitSearchUrl' :enterpriseResourceBaseUrl="enterpriseResourceBaseUrl"> </v-topBar>
    <v-registerTop :navTitle="navTitle" :webConfigInfo='webConfigInfo'></v-registerTop>
    <!--<div class="setNavBg">-->
    <!--<v-header :navigationColumnInfos='navigationColumnInfos' :webConfigInfo='webConfigInfo'  :footerColumnInfos='footerColumnInfos' :paramInfo='paramInfo'></v-header>-->
    <!--</div>-->
    <div class="registerStepTit"><h3>找回密码</h3></div>
    <div class="registerStepCon">
      <el-steps :active="2" align-center>
        <el-step title="1 基本信息"></el-step>
        <el-step title="2 验证身份"></el-step>
        <el-step title="3 重置密码"></el-step>
        <el-step title="4 操作完成"></el-step>
      </el-steps>
      <div class="baseInforConCon">
        <el-form :model="baseForm" :rules="rules" ref="baseForm" label-width="100px" class="demo-ruleForm">
          <!-- <el-form-item label="密码" prop="password">
            <el-input type="password" v-model="baseForm.password" :minlength="6" :maxlength="20"></el-input>
          </el-form-item> -->
          <el-form-item label="新密码" prop="newPassword">
            <el-input type="password" v-model="baseForm.newPassword" ref="newPassword" :minlength="6" :maxlength="20"></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="confirmPassword">
            <el-input type="password" v-model="baseForm.confirmPassword" :minlength="6" :maxlength="20"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <el-button @click="goToHref('/passwordComplete')">下一步</el-button>
    </div>
    
    <v-footer  :webConfigInfo='webConfigInfo'  :footerColumnInfos='footerColumnInfos'></v-footer>
  </div>
</template>
<script>
  import header from '@/components/v-header/header'
  import topBar from '@/components/topBar'
  import registerTop from '@/components/registerTop'
  import footer from '@/components/v-footer'
  export default {
    props: [],
    data () {
      var checkPassword = (rule, value, callback) => {
        if (value!=this.$refs.newPassword.value) {
          return callback(new Error('确认密码与新密码必须相同！'));
        }else{
          return callback();
        }
        
      };
      var checkPasswordExt = (rule, value, callback) => {
        if (value.indexOf(" ")!=-1) {
          return callback(new Error('密码不能包含空格'));
        }else{
          return callback();
        }
      };
      return {
        email:'',
        verifyCode:'',
        currentUserId:'',
        userAgreementVisible: false,
        privacyPolicyVisible: false,
        centerDialogVisible: false,
        navigationColumnInfos: [],
        footerColumnInfos: [],
        webConfigInfo: {},
        checkList:[],
        navTitle:'找回密码',
        verifyBtn:'获取验证码',
        disabledBtn:false,
        abroadShow:false,
        baseForm: {
          password: '',
          newPassword: '',
          confirmPassword:''
        },
        rules: {
          newPassword: [
            { required: true, message: '请输入新密码', trigger: 'blur' },
            { min: 6, max: 20, message: '新密码长度在 6 到 20 个字符', trigger: 'blur' },
            { validator: checkPasswordExt, trigger: 'blur' }

          ],
          confirmPassword: [
            { required: true, message: '请输入确认密码', trigger: 'blur' },
            { min: 6, max: 20, message: '确认密码长度在 6 到 20 个字符', trigger: 'blur' },
            { validator: checkPassword, trigger: 'blur' },
            { validator: checkPasswordExt, trigger: 'blur' }
          ]
        },
        hitSearchUrl:'',
        enterpriseResourceBaseUrl:'',
        yellowPageColumn:{},
        productAndSolutionColumn:{}
      }
    },
    components: {
      'v-header': header,
      'v-topBar': topBar,
      'v-registerTop': registerTop,
      'v-footer': footer
    },
    created () {
      let query = this.$route.query;
      this.currentUserId = query.userId;
      this.email=query.email;
      this.verifyCode=query.verifyCode;
      this.$axios.post('/onelink.mdata.main.api/mainInfo/findMainCommonInfo', {
      }).then((res) => {
        this.data = res.data;
        this.webConfigInfo = this.data.webConfigInfoDto;
        this.footerColumnInfos = this.data.footerColumnInfos;
        this.navigationColumnInfos = this.data.navigationColumnInfos;
        this.yellowPageColumn = this.data.yellowPageColumn;
        this.productAndSolutionColumn = this.data.productAndSolutionColumn;
        this.hitSearchUrl = this.data.hitSearchUrl;
        this.enterpriseResourceBaseUrl = this.data.enterpriseResourceBaseUrl;
      }).catch((err) => {
        console.log(err)
      })
    },
    mounted () {
    },
    methods: {
      goToHref(val){
        
          this.$refs['baseForm'].validate((valid) => {
            if (valid) {
              this.$axios.post('/onelink.mdata.main.api/user/changePasswordExt', 
              {
                userId:this.currentUserId,
                newPassword:this.baseForm.newPassword,
                verifyCode:this.verifyCode,
                email:this.email
              }).then((res) => {
                 this.$confirm('是否重置密码', '提示', {
                    confirmButtonText: '是',
                    cancelButtonText: '否',
                    type: 'warning'
                  }).then(() => {
                    this.data = res.data;
                    let changeFlag = this.data.data;
                    if(changeFlag){
                      this.$router.push({path: val})
                    }else{
                      this.$message({
                        message: this.data.msg,
                        type: 'error'
                      });
                      return false;
                    }
                  }).catch(() => {
                    
                  });
              }).catch((err) => {
                console.log(err)
              })
            } else {
              console.log('error submit!!');
              return false;
            }
          });
       
        
      },
      
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/findPassword/resetPassword.vue